module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATgAAAAgCAMAAACxU5QaAAAAJFBMVEVHcEz/dV/+b1/+eF39amD9a2H9a2D+dV/+dl/+cV79bF39bF7+FeqyAAAADHRSTlMAHp0Q3/7DRDFYa33Icl7FAAAAz0lEQVR42u3X3Q6DIAyGYQoUitz//Y626uFmyBbC8j2Jx5rXhp8AAAAAAADwexTDflJMy7tlLvt1K1zS8m7MZb9urOUWz1sdz27dsuSl5cherx+xWTcK9OVyKSRFSkhUleqaO1wf/OVWbrNu/tP7cJh2NFedODLJhLcsmgxXqTNRdMVkw4qCasw9bCIyS1DCKqtioutnziuj9/tc7uHE9T+ZuHvkXDVSxZDQkMgGLmGNu9c47KpzuyrOcXPnONwc5m4OuKtO3lUBAAAAAOC5F2beCgv2gYAtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/rule-title-icon.png
// module id = MFKl
// module chunks = 215